import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import Layout from '../components/Layout';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';
import { Button } from '../components/ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = params.get('token');
    if (!token) {
      setStatus('error');
      setMessage('No verification token provided.');
      return;
    }
    axios.get(`${API}/auth/verify-email?token=${token}`)
      .then(res => { setStatus('success'); setMessage(res.data.message); })
      .catch(err => { setStatus('error'); setMessage(err.response?.data?.detail || 'Verification failed.'); });
  }, [params]);

  return (
    <Layout>
      <div className="min-h-[60vh] flex items-center justify-center" data-testid="verify-email-page">
        <div className="bg-card border border-border rounded-sm p-10 max-w-md w-full text-center">
          {status === 'loading' && (
            <>
              <Loader2 className="h-12 w-12 text-[#78BE20] mx-auto animate-spin mb-4" />
              <p className="text-muted-foreground">Verifying your email...</p>
            </>
          )}
          {status === 'success' && (
            <>
              <CheckCircle2 className="h-16 w-16 text-[#78BE20] mx-auto mb-4" />
              <h1 className="text-2xl font-bold text-foreground mb-2">Email Verified!</h1>
              <p className="text-muted-foreground mb-6">{message}</p>
              <Link to="/account">
                <Button className="bg-[#78BE20] text-black hover:bg-[#65a31b]" data-testid="go-to-account-btn">
                  Go to My Account
                </Button>
              </Link>
            </>
          )}
          {status === 'error' && (
            <>
              <XCircle className="h-16 w-16 text-red-500 mx-auto mb-4" />
              <h1 className="text-2xl font-bold text-foreground mb-2">Verification Failed</h1>
              <p className="text-muted-foreground mb-6">{message}</p>
              <Link to="/login">
                <Button variant="outline" className="border-zinc-700">Go to Login</Button>
              </Link>
            </>
          )}
        </div>
      </div>
    </Layout>
  );
}
